import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import Icon from "@mui/material/Icon";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import MyDataTable from "components/DataTable";
import PageTitle from "components/PageTitle";
import tableData from "DBTables/operai.json"
import { ROLES, STATUS_WORKER } from "constant";

import Modal from '@mui/material/Modal';
import * as ajax from "helpers/ajax";

export default class Operaio extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            operai: [],
            loading: true,
            selectedOperaio: null,
            costoOrario: 0,
            costoStraordinario: 0,
            costoNotturno: 0,
            openCostModal: false,
            giorniLavorati: [],
            dataInizio: '',
            dataFine: '',
            loadingGiorni: false,
            loadingSave: false,
            progressoSalvataggio: 0 // Nuovo stato per tracciare l'avanzamento del salvataggio
        };
    }

    handleEuroAction = (data) => {
        this.setState({
            openCostModal: true,
            selectedOperaio: data,
            costoOrario: data.costo_orario || "",
            costoStraordinario: data.costo_straordinario || "",
            costoNotturno: data.costo_notturno || "",
            dataInizio: "",
            dataFine: ""
        });
    }

    handleCloseCostModal = () => {
        this.setState({
            openCostModal: false,
            selectedOperaio: null,
            dataInizio: "",
            dataFine: "",
            costoOrario: "",
            costoStraordinario: "",
            costoNotturno: "",
            giorniLavorati: [],
            loadingGiorni: false,
            loadingSave: false
        });
    }

    // Funzione per scaricare i giorni lavorati dalla data di variazione in poi
    handleDateChange = (field, value) => {
        this.setState({ [field]: value }, () => {
            // Se la data variazione è stata selezionata, scarica i giorni lavorati
            if (this.state.dataInizio && this.state.selectedOperaio) {
                this.downloadGiorniLavorati();
            }
        });
    }

    downloadGiorniLavorati = (callback) => {
        this.setState({ loadingGiorni: true });
        
        const { selectedOperaio, dataInizio, dataFine } = this.state;
        
        // Costruiamo la query string con URLSearchParams
        const queryParams = new URLSearchParams();
        queryParams.append('filters[operaio]', selectedOperaio.id);
        queryParams.append('filters[data][$gte]', dataInizio);
        
        // Se c'è dataFine, aggiungiamo il filtro per il limite superiore
        if (dataFine) {
            queryParams.append('filters[data][$lte]', dataFine);
        }
        
        ajax.ajaxGetStrapi(`operai-commesses?${queryParams.toString()}`, (response) => {
            // Determiniamo quale struttura ha la risposta
            let dataArray = null;
            
            if (response && Array.isArray(response)) {
                // La risposta è già un array di giorni lavorati
                dataArray = response;
            } else if (response && response.data && Array.isArray(response.data)) {
                // Formato alternativo con response.data
                dataArray = response.data;
            }
            
            if (dataArray) {
                // Processiamo i dati
                const giorniLavorati = dataArray.map(giorno => {
                    // Mappiamo i campi dalla risposta dell'API al nostro formato
                    return {
                        id: giorno.id,
                        data: giorno.data,
                        ore_lavoro: giorno.ore || 0,
                        commessa: giorno.commessa,
                        stato: giorno.stato || "ORDINARIO",
                        costo_orario_attuale: giorno.costo_orario
                    };
                });
                
                this.setState({ 
                    giorniLavorati,
                    loadingGiorni: false 
                }, () => {
                    if (callback && typeof callback === 'function') {
                        callback();
                    }
                });
            } else {
                // Nessun dato valido trovato
                this.setState({ 
                    giorniLavorati: [],
                    loadingGiorni: false 
                }, () => {
                    if (callback && typeof callback === 'function') {
                        callback();
                    }
                });
            }
        }, (error) => {
            console.error("Errore nel recupero dei giorni lavorati:", error);
            this.setState({ 
                loadingGiorni: false,
                giorniLavorati: [] 
            }, () => {
                if (callback && typeof callback === 'function') {
                    callback();
                }
            });
        });
    }

    // Funzione di utilità per categorizzare gli stati in tre gruppi: ORDINARIO, STRAORDINARI, NOTTURNO
    categorizzaStato = (stato) => {
        if (!stato) return "ORDINARIO";
        
        const statoUpper = stato.toUpperCase().trim();
        
        if (statoUpper === "STRAORDINARI" || statoUpper === "STRAORDINARIO") {
            return "STRAORDINARI";
        } else if (statoUpper === "NOTTURNO") {
            return "NOTTURNO";
        } else {
            // Tutti gli altri stati (PERMESSO, FERIE, MALATTIA, ASSENZA, SOSPESO, PATERNITA/MATERNITA, ecc.)
            return "ORDINARIO";
        }
    }

    handleSaveCosts = () => {
        // Attiva lo stato di caricamento
        this.setState({ loadingSave: true });

        const { giorniLavorati, costoOrario, costoStraordinario, costoNotturno, selectedOperaio, dataFine } = this.state;

        // Funzione per aggiornare i giorni lavorati
        const aggiornaGiorniLavorati = () => {
            // Totali per categoria
            const riepilogoCategorie = {
                ORDINARIO: 0,
                STRAORDINARI: 0,
                NOTTURNO: 0
            };

            // Contatori per il feedback finale
            let salvatiFalliti = {
                successi: 0,
                errori: 0
            };

            if (giorniLavorati.length > 0) {
                let completati = 0;
                giorniLavorati.forEach(giorno => {
                    const categoriaStato = this.categorizzaStato(giorno.stato);
                    riepilogoCategorie[categoriaStato]++;
                    let costoOrarioEffettivo;
                    switch (categoriaStato) {
                        case "STRAORDINARI":
                            costoOrarioEffettivo = costoStraordinario;
                            break;
                        case "NOTTURNO":
                            costoOrarioEffettivo = costoNotturno;
                            break;
                        default:
                            costoOrarioEffettivo = costoOrario;
                            break;
                    }
                    const datiAggiornati = {
                        data: {
                            costo_orario: costoOrarioEffettivo
                        }
                    };
                    ajax.ajaxPutStrapi(`operai-commesses/${giorno.id}`, datiAggiornati, (response) => {
                        if (response && (response.id || (response.data && response.data.id))) {
                            salvatiFalliti.successi++;
                        } else {
                            salvatiFalliti.errori++;
                        }
                        completati++;
                        this.setState({ progressoSalvataggio: Math.round((completati / giorniLavorati.length) * 100) });
                        if (completati === giorniLavorati.length) {
                            let messaggioFinale = `Aggiornati ${salvatiFalliti.successi} giorni lavorati su ${giorniLavorati.length}`;
                            if (salvatiFalliti.errori > 0) {
                                messaggioFinale += `\nErrori durante il salvataggio: ${salvatiFalliti.errori}`;
                            }
                            messaggioFinale += `\n\nRiepilogo per categoria:`;
                            if (riepilogoCategorie.ORDINARIO > 0) {
                                messaggioFinale += `\nOrdinario (${costoOrario}€): ${riepilogoCategorie.ORDINARIO}`;
                            }
                            if (riepilogoCategorie.STRAORDINARI > 0) {
                                messaggioFinale += `\nStraordinari (${costoStraordinario}€): ${riepilogoCategorie.STRAORDINARI}`;
                            }
                            if (riepilogoCategorie.NOTTURNO > 0) {
                                messaggioFinale += `\nNotturno (${costoNotturno}€): ${riepilogoCategorie.NOTTURNO}`;
                            }
                            this.setState({
                                loadingSave: false,
                                openCostModal: false
                            });
                        }
                    });
                });
            } else {
                // Se non ci sono giorni lavorati da aggiornare
                this.setState({ 
                    loadingSave: false,
                    openCostModal: false
                });
                alert(dataFine 
                    ? "Nessun giorno lavorato da aggiornare nel periodo selezionato." 
                    : "Costi operaio aggiornati. Nessun giorno lavorato da aggiornare nel periodo selezionato.");
            }
        };

        // Se c'è dataFine, NON salva i costi nella tabella operaio, aggiorna solo i giorni lavorati
        if (dataFine) {
            aggiornaGiorniLavorati();
        } else {
            // Se NON c'è dataFine, prima salva i costi nella tabella operaio, poi aggiorna i giorni lavorati
            const datiOperaio = {
                data: {
                    costo_orario: costoOrario,
                    costo_straordinario: costoStraordinario,
                    costo_notturno: costoNotturno
                }
            };

            ajax.ajaxPutStrapi(`operaios/${selectedOperaio.id}`, datiOperaio, (responseOperaio) => {
                // Dopo aver salvato i costi dell'operaio, aggiorna i giorni lavorati
                aggiornaGiorniLavorati();
            }, (error) => {
                // Errore nel salvataggio dei costi dell'operaio
                console.error("Errore nel salvataggio dei costi operaio:", error);
                this.setState({ loadingSave: false });
                alert("Errore durante il salvataggio dei costi operaio");
            });
        }
    }

    render() {
        return (
            <DashboardLayout>
                <DashboardNavbar />
                <PageTitle
                    text={"Gestione operai"}
                    icon={"engineering"}
                />
                <MDBox>
                    <MyDataTable
                        tableData={tableData}
                        edit={[ROLES.admin, ROLES.risorse_umane].includes(global.user.ruolo) ? true : false}
                        delete={[ROLES.admin, ROLES.risorse_umane].includes(global.user.ruolo) ? true : false}
                        add={[ROLES.admin, ROLES.risorse_umane].includes(global.user.ruolo) ? true : false}
                        icon={"Personale"}
                        customAction={global.user.ruolo === ROLES.admin ? [
                            {
                                icon: "euro",
                                color: "secondary",
                                function: this.handleEuroAction
                            }
                        ] : []}
                    />
                </MDBox>

                {/* Modal per modifica costi */}
                <Modal
                    open={this.state.openCostModal}
                    onClose={this.handleCloseCostModal}
                    style={{
                        margin: "auto", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center"
                    }}
                >
                    <MDBox
                        bgColor={"white"}
                        borderRadius="lg"
                        p={2}
                        minWidth={500}
                        sx={{ maxHeight: "90%", overflow: "visible" }}
                    >
                        <MDBox
                            variant="gradient"
                            bgColor="info"
                            borderRadius="lg"
                            coloredShadow="info"
                            mx={2}
                            mt={-3}
                            p={2}
                            mb={1}
                            textAlign="center"
                        >
                            <MDTypography variant="h2" fontWeight="medium" color="white" mt={1}>
                                Modifica Costi Operaio
                            </MDTypography>
                            {this.state.selectedOperaio && (
                                <MDTypography variant="h6" color="white">
                                    {this.state.selectedOperaio.nome} {this.state.selectedOperaio.cognome}
                                </MDTypography>
                            )}
                        </MDBox>

                        <Grid p={4}>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <MDInput
                                        type="date"
                                        label="Data Inizio Variazione *"
                                        value={this.state.dataInizio}
                                        onChange={(e) => this.handleDateChange('dataInizio', e.target.value)}
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <MDInput
                                        type="date"
                                        label="Data Fine Variazione (opzionale)"
                                        value={this.state.dataFine}
                                        onChange={(e) => this.handleDateChange('dataFine', e.target.value)}
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        disabled={!this.state.dataInizio}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <MDInput
                                        type="number"
                                        label="Costo Orario (€/h)"
                                        value={this.state.costoOrario}
                                        onChange={(e) => this.setState({ costoOrario: e.target.value })}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <MDInput
                                        type="number"
                                        label="Costo Straordinario (€/h)"
                                        value={this.state.costoStraordinario}
                                        onChange={(e) => this.setState({ costoStraordinario: e.target.value })}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <MDInput
                                        type="number"
                                        label="Costo Notturno (€/h)"
                                        value={this.state.costoNotturno}
                                        onChange={(e) => this.setState({ costoNotturno: e.target.value })}
                                        fullWidth
                                    />
                                </Grid>
                            </Grid>

                            {/* Piccolo specchietto informativo sulle date che verranno modificate */}
                            {this.state.dataInizio && (
                                <MDBox mt={3} p={2} borderRadius="lg" bgColor="light" sx={{ border: '1px dashed #ccc' }}>
                                    <MDTypography variant="subtitle2" fontWeight="medium" color="info">
                                        Riepilogo Modifiche
                                    </MDTypography>
                                    <Grid container mt={1}>
                                        <Grid item xs={6}>
                                            <MDTypography variant="caption" fontWeight="bold">Periodo di variazione:</MDTypography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <MDTypography variant="caption">
                                                {this.state.dataFine 
                                                    ? `Dal ${new Date(this.state.dataInizio).toLocaleDateString('it-IT')} al ${new Date(this.state.dataFine).toLocaleDateString('it-IT')}`
                                                    : `Dal ${new Date(this.state.dataInizio).toLocaleDateString('it-IT')} in poi`
                                                }
                                            </MDTypography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <MDTypography variant="caption" fontWeight="bold">Operaio:</MDTypography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <MDTypography variant="caption">
                                                {this.state.selectedOperaio?.nome} {this.state.selectedOperaio?.cognome}
                                            </MDTypography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <MDTypography variant="caption" fontWeight="bold">Corrispondenze trovate:</MDTypography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <MDTypography variant="caption" color={this.state.giorniLavorati.length > 0 ? "success" : "warning"}>
                                                {this.state.giorniLavorati.length}
                                            </MDTypography>
                                        </Grid>
                                        {this.state.giorniLavorati.length > 0 && (
                                            <>
                                                <Grid item xs={6}>
                                                    <MDTypography variant="caption" fontWeight="bold">Stati presenti:</MDTypography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    {(() => {
                                                        // Raggruppiamo gli stati in tre categorie: ORDINARIO, STRAORDINARI, NOTTURNO
                                                        const statiRaggruppati = {
                                                            "ORDINARIO": 0,
                                                            "STRAORDINARI": 0,
                                                            "NOTTURNO": 0
                                                        };
                                                        
                                                        this.state.giorniLavorati.forEach(g => {
                                                            const categoriaStato = this.categorizzaStato(g.stato);
                                                            statiRaggruppati[categoriaStato] += 1;
                                                        });
                                                        
                                                        // Filtriamo gli stati con conteggio > 0
                                                        const statiFinali = Object.entries(statiRaggruppati)
                                                            .filter(([_, count]) => count > 0);
                                                        
                                                        return (
                                                            <MDTypography variant="caption">
                                                                {statiFinali.map(([stato, count], idx) => (
                                                                    <span key={idx}>
                                                                        {stato}: <span style={{fontWeight: 'bold'}}>{count}</span>
                                                                        {idx < statiFinali.length - 1 ? ', ' : ''}
                                                                    </span>
                                                                ))}
                                                            </MDTypography>
                                                        );
                                                    })()}
                                                </Grid>
                                            </>
                                        )}
                                        <Grid item xs={12} mt={1}>
                                            <MDTypography variant="caption" color="text">
                                                {this.state.dataFine 
                                                    ? `I costi saranno aggiornati per tutti i giorni lavorati nel periodo specificato (dal ${new Date(this.state.dataInizio).toLocaleDateString('it-IT')} al ${new Date(this.state.dataFine).toLocaleDateString('it-IT')}).`
                                                    : "I costi saranno aggiornati per tutti i giorni lavorati dalla data di variazione in poi. I nuovi costi verranno applicati anche ai giorni che saranno aggiunti in futuro."
                                                }
                                            </MDTypography>
                                        </Grid>
                                    </Grid>
                                </MDBox>
                            )}

                            <Grid container spacing={2} mt={3}>
                                <Grid item xs={12}>
                                    <MDButton
                                        variant="gradient"
                                        color="info"
                                        fullWidth
                                        onClick={this.handleSaveCosts}
                                        disabled={this.state.loadingGiorni || this.state.loadingSave}
                                        sx={{ 
                                            display: 'flex', 
                                            alignItems: 'center', 
                                            justifyContent: 'center',
                                            gap: 1
                                        }}
                                    >
                                        {this.state.loadingSave ? (
                                            <Icon className="animate-spin" sx={{ transform: 'scaleX(-1)' }}>autorenew</Icon>
                                        ) : (
                                            <Icon>autorenew</Icon>
                                        )}
                                        {this.state.loadingSave ? "Salvataggio in corso..." : "Aggiorna Costi"}
                                    </MDButton>
                                </Grid>
                                {this.state.loadingSave && (
                                    <Grid item xs={12}>
                                        <MDTypography variant="caption" color="info" textAlign="center" sx={{ display: 'block' }}>
                                            Aggiornamento dei costi in corso, attendere il completamento...
                                        </MDTypography>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    </MDBox>
                </Modal>
            </DashboardLayout>
        )
    }
}


